import React from 'react'
import Style from './Security.module.css'

const Security = () => {
  return (
    <>
      <div className='Navbar__Height'></div>
      <div className={Style.Security__Page__Section}>
        <div className={Style.Header__Section}>
          <div className='container'>
            <h1 className={Style.Page__Title}>Security</h1>
            <h5 className={Style.Sub__Title}>
              At Fyntiq LLC, security is at the core of everything we do. We
              take extensive measures to protect your data, your business, and
              your customers.
            </h5>
          </div>
        </div>
        <div className={Style.Content__Section}>
          <div className='container'>

            <h4>Data Security</h4>
            <p>
              Fyntiq is Level 1 PCI-DSS compliant. This means that every year we
              undergo a third-party audit to validate our practices and ensure
              we are protecting you and your customers.
            </p>

            <h5>Secure Data Transmission</h5>
            <p>
              When you load a page in your browser or upload something to Fyntiq,
              all information is encrypted while moving over the internet. We
              use up to 256-bit TLS encryption—the same strength used in online
              banking and shopping. We also support a wide variety of modern
              ciphers to ensure the highest level of protection, based on your
              browser.
            </p>

            <h5>Tokenization</h5>
            <p>
              Fyntiq never stores credit card numbers. Credit card information
              is sent directly from the app or browser to our payments
              processor, and Fyntiq receives a secure token in return. This token
              authorizes transactions without exposing your card details.
            </p>

            <h5>Secure Data Storage</h5>
            <p>
              Your accounting and financial data is stored on servers with strict
              physical access protocols. Facilities are monitored 24/7, and only
              authorized personnel may access them. Data is protected by advanced
              digital safeguards.
            </p>

            <h5>Security Testing</h5>
            <p>
              Fyntiq employs multiple layers of testing. We test internally and
              also engage third-party firms to perform regular vulnerability
              assessments and penetration tests. In addition, we run a private
              bug bounty program through HackerOne, where independent security
              researchers continuously test our systems. Security is ongoing, and
              we go above and beyond industry standards.
            </p>

            <h5>Transparency</h5>
            <p>
              We want you and your customers to know exactly how we protect your
              data. Our <a href="https://fyntiq.com/privacy" target="_blank" rel="noreferrer">Privacy Policy</a> 
              explains our practices in detail. We’ve also written a dedicated 
              <a href="https://fyntiq.com/customer-privacy-policy" target="_blank" rel="noreferrer"> Customer Privacy Policy</a> 
              to give your customers peace of mind when paying through Fyntiq.
            </p>

            <h4>Mobile Security</h4>
            <p>
              Passwords are encrypted at collection, during transmission, and at
              rest. Communications between our apps and servers use Transport
              Layer Security (TLS), the successor to SSL. Sensitive information,
              such as credit card numbers, is never stored on your device.
            </p>

            <h4>Fraud Prevention</h4>
            <p>
              We use layered security and third-party anti-fraud tools to monitor
              transactions and detect unusual activity. Our risk analysts review
              high-risk behavior in real time to keep our platform safe. We also
              support you with chargeback prevention best practices, and our team
              will help you build the strongest case possible if disputes arise.
            </p>

            <h4>Bank Access Security</h4>
            <p>
              Fyntiq’s connections with financial institutions are strictly
              read-only. We cannot move money without your authorization. To
              enhance protection, Fyntiq works with industry-leading banking data
              providers trusted by some of the world’s largest financial
              institutions.
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default Security